var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgOutsideEmploymentActivities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 15.7950638 15.7950638 15.7950638 15.7950638 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SELECT-REPORT-TYPE-v1",
    transform: "translate(-505.000000, -486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(505.000000, 486.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    fill: "#E77D66",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.853617,2.99608511 C14.925617,2.99608511 15.7950638,3.86553191 15.7950638,4.93753191 L15.7950638,7.52782979 L14.1661277,8.09055319 C12.7458723,8.57974468 11.2820426,8.82314894 9.80459574,8.9613617 L9.80459574,6.80851064 L5.99217021,6.80851064 L5.99217021,8.96544681 C4.4507234,8.84187234 3.13565957,8.61038298 1.62893617,8.09055319 L0,7.52782979 L0,4.93753191 C0,3.86553191 0.869787234,2.99608511 1.94280851,2.99608511 L13.853617,2.99608511 Z",
    id: "Fill-1",
    fill: "#CE9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80459574,8.9613617 L9.80459574,6.80851064 L5.99217021,6.80851064 L5.99217021,8.96544681 C4.4507234,8.84187234 3.13565957,8.61038298 1.62893617,8.09055319 L0,7.52782979 L0.272680851,7.62246809 L0.272680851,15.188766 C0.272680851,15.5240851 0.544,15.7950638 0.878978723,15.7950638 L14.9160851,15.7950638 C15.2514043,15.7950638 15.5240851,15.5240851 15.5240851,15.188766 L15.5240851,7.62246809 L15.7950638,7.52782979 L14.1661277,8.09055319 C12.7458723,8.57974468 11.2820426,8.82314894 9.80459574,8.9613617",
    id: "Fill-3",
    fill: "#986C48"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFD16C",
    mask: "url(#mask-2)",
    points: "4.35778723 2.99574468 6.53582979 2.99574468 6.53582979 2.17804255 4.35778723 2.17804255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFD16C",
    mask: "url(#mask-2)",
    points: "9.25923404 2.99574468 11.4386383 2.99574468 11.4386383 2.17804255 9.25923404 2.17804255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80459574,1.48255319 L9.80459574,2.17804255 L10.893617,2.17804255 L10.893617,1.60374468 C10.893617,0.717957447 10.1756596,7.10542736e-15 9.28987234,7.10542736e-15 L6.50519149,7.10542736e-15 C5.61974468,7.10542736e-15 4.90144681,0.717957447 4.90144681,1.60374468 L4.90144681,2.17804255 L5.99217021,2.17804255 L5.99217021,1.48255319 C5.99217021,1.17957447 6.29923404,0.973276596 6.57974468,1.08902128 C7.42434043,1.43897872 8.37242553,1.43897872 9.21668085,1.08902128 C9.49617021,0.973276596 9.80459574,1.17957447 9.80459574,1.48255319",
    id: "Fill-8",
    fill: "#604530",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFD16C",
    mask: "url(#mask-2)",
    points: "11.4389787 14.4333617 14.162383 14.4333617 14.162383 13.3443404 11.4389787 13.3443404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#604530",
    mask: "url(#mask-2)",
    points: "8.17021277 11.7099574 7.62485106 11.7099574 6.80851064 10.893617 6.80851064 10.0772766 8.98655319 10.0772766 8.98655319 10.893617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#604530",
    mask: "url(#mask-2)",
    points: "6.80851064 6.80851064 8.98655319 6.80851064 8.98655319 2.99608511 6.80851064 2.99608511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFD16C",
    mask: "url(#mask-2)",
    points: "5.99217021 10.0772766 9.80459574 10.0772766 9.80459574 6.80851064 5.99217021 6.80851064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#604530",
    mask: "url(#mask-2)",
    points: "6.80851064 9.25923404 8.98655319 9.25923404 8.98655319 6.80851064 6.80851064 6.80851064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89753191,9.53191489 C7.74740426,9.53191489 7.62485106,9.40970213 7.62485106,9.25923404 L7.62485106,8.17021277 C7.62485106,8.02008511 7.74740426,7.89753191 7.89753191,7.89753191 C8.048,7.89753191 8.17021277,8.02008511 8.17021277,8.17021277 L8.17021277,9.25923404 C8.17021277,9.40970213 8.048,9.53191489 7.89753191,9.53191489",
    id: "Fill-14",
    fill: "#CBB292",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideEmploymentActivities);
export default __webpack_public_path__ + "static/media/outside-employment-activities.62bd58c377a3864095c3aeb742a4170e.svg";
export { ForwardRef as ReactComponent };